<template>
  <ComingSoon />
</template>

<script>
import ComingSoon from '@/components/ComingSoon.vue'

export default {
  name: 'Services',

  components: {
    ComingSoon,
  }
}
</script>

